import { render, staticRenderFns } from "./addDeal.vue?vue&type=template&id=212d424a&scoped=true"
import script from "./addDeal.vue?vue&type=script&lang=js"
export * from "./addDeal.vue?vue&type=script&lang=js"
import style0 from "./addDeal.vue?vue&type=style&index=0&id=212d424a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212d424a",
  null
  
)

export default component.exports